import { render, staticRenderFns } from "./allCustomManage.vue?vue&type=template&id=39c9463a&scoped=true&"
import script from "./allCustomManage.vue?vue&type=script&lang=js&"
export * from "./allCustomManage.vue?vue&type=script&lang=js&"
import style0 from "./allCustomManage.vue?vue&type=style&index=0&id=39c9463a&prod&scoped=true&lang=css&"
import style1 from "./allCustomManage.vue?vue&type=style&index=1&id=39c9463a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c9463a",
  null
  
)

export default component.exports